import { reduce } from "lodash"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { StateActions } from "store/modules/state/actions"
import feathers from "utility/client"

export const useStatistics = (
  businessId,
  onUpdate,
  onDelete,
  onSubscribe = () => {},
  shouldSubscribe = true
) => {
  const dispatch = useDispatch()

  const unsubscribe = () => {
    feathers.io.removeAllListeners('statistic added')
    feathers.io.removeAllListeners('statistic deleted')

    if (business) {
      feathers.io.emit('unsubscribe', 'statistic', {business}, {}, (e) => {
        if (e) {
          console.log(`Unsubscribe failed for ${business}`, e)
          return
        }
      })
    }

    dispatch(StateActions.set({}))
    console.log(`Unsubscribed updates from ${business}`)
  }

  const subscribe = () => {
    if (window.__STATISTICS_SUBSCRIBED__) {
      unsubscribe()
    }

    feathers.io.emit('subscribe', 'statistic', {business: businessId}, {}, (e, response) => {
      if (e) {
        console.log(`Stats subscription update failed`, e)
        return
      }

      if (response.data.length) {
        dispatch(StateActions.set(
          reduce(
            response.data,
            (acc, s) => ({...acc, [s.device]: s}),
            {}
          )
        ))
      } else {
        console.log('Subscribed, no initial state present')
      }

      onSubscribe(response)
    })

    feathers.io.on('statistic added', onUpdate)
    feathers.io.on('statistic deleted', onDelete)

    window.__STATISTICS_SUBSCRIBED__ = true

    console.log(`Subscribed statistics from ${business}`)
  }

  const business = useMemo(() => businessId, [businessId])

  useEffect(() => {
    if (shouldSubscribe) {
      if (business) {
        subscribe()
      }
    }
  }, [business])

  return {
    subscribe,
    unsubscribe
  }
}
